import { ISuggestion, IRating } from '@entities/review/model/types'
import { IWaiter, IChekTransactionResponse } from '@entities/order/model/types'

export const generateWishes = (
  rating: number,
  suggestions: ISuggestion[],
  ratingInfo: IRating[]
) => {
  const tagsArr =
    rating > 0 && rating < 4
      ? suggestions
      : ratingInfo

  let tags = ''
  if (rating > 0) {
    tagsArr.forEach((item: ISuggestion | IRating, index: number) => {
      if (rating > 0 && rating < 4) {
        const i = item as ISuggestion
        tags += index + 1 !== tagsArr.length ? i.label + ', ' : i.label
      } else {
        const i = item as IRating
        tags += index + 1 !== tagsArr.length
          ? i.label1 + ' ' + i.label2 + ', '
          : i.label1 + ' ' + i.label2
      }
    })
  }

  return tags.length > 0 ? 'Пожелания: ' + tags : ''
}

export const generateWaiterName = (waiter: IWaiter | null) => {
  if (waiter && waiter.display_name) {
    return waiter.display_name
  }
  return (waiter && waiter.name) || ' '
}

export const generateMessage = (
  transaction: IChekTransactionResponse | null,
  tableCode: string,
  waiterName: string,
  comment: string,
  rating: number,
  wishes: string
) => {
  return 'Заказ# ' + (transaction ? transaction.session_ids.order_uuids[0] : '') +
    '\n' +
    'Стол: ' +
    tableCode +
    '\n' +
    'Официант: ' +
    waiterName +
    '\n' +
    'Комментарий: ' +
    comment +
    '\n' +
    'Рейтинг: ' +
    rating +
    '\n' +
    wishes
}
